module.exports = __webpack_public_path__ + "static/media/right-top-img3.a6f66305.png";